import { api } from '@/lib/api'

type FileResponse = {
  fileName: string
}

export function getCSVFiles({ id }: { id: string }) {
  return api.get<FileResponse[]>(`/v1/me/bulk-payment-files/${id}`)
}
